<nz-collapse [nzBordered]="true">
  <nz-table [nzData]="dataList" [nzShowPagination]="false">
    <thead>
      <tr>
        <th></th>
        <th>{{'Type' | MMSTranslate}}</th>
        <th>{{'Status' | MMSTranslate}}</th>
        <th>{{'Requested Date' | MMSTranslate}}</th>
        <th>{{'Type' | MMSTranslate}}</th>
        <th>{{'Action' | MMSTranslate}}</th>
      </tr>
    </thead>
    <tbody *ngFor="let data of dataList; let i = index">
      <!-- Row toggle icon -->
      <tr>
        <td>
          <i nz-icon *ngIf="!data.panel" nzType="right" nzTheme="outline" (click)="data.panel = true"></i>
          <i nz-icon *ngIf="data.panel" nzType="down" nzTheme="outline" (click)="data.panel = false"></i>
        </td>
        <!-- Row data -->
        <td>{{data?.collaborationTypeCd | technicalTranslate}}</td>
        <td>{{data.status | technicalTranslate:'followupStatusCd'}}</td>
        <td>{{data.requestedTs | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR:'MM.dd.yyyy HH:mm' || ''}}</td>
        <td>
          {{data.collaborationTypeCd == 'FOLLOWUP' ? (data.collaborationTypeCd | technicalTranslate) : (data.categoryCd
          | technicalTranslate)}}
        </td>
        <!-- Action links -->
        <td *ngIf="(data.status =='DRAFT' || data.status =='CREATED')">
          <a (click)="noReply(data.guid,'No Reply')">No Reply</a> |
          <a (click)="openReplyModule(data.guid,'Reply',data.collaborationTypeCd)">Reply</a>
        </td>
        <td *ngIf="!(data.status =='DRAFT' &&  data.status =='CREATED')"></td>
      </tr>

      <!-- Expandable panel for each row -->
      <tr *ngIf="data.panel">
        <td colspan="6">
          <ng-container>
            <nz-collapse-panel [nzActive]="data.panel" nzShowArrow="false">
              <!-- Comment list -->
              <nz-list [nzDataSource]="data.data" [nzRenderItem]="item" [nzItemLayout]="'horizontal'">
                <ng-template #item let-item>
                  <div class="m-b-10">
                    <!-- Conversation bubbles -->
                    <ng-container *ngFor="let conData of item.conversations">
                      <div class="speech-wrapper" *ngIf="conData.createdUser && loggedInUser">
                        <!-- Message from others -->
                        <div class="flex flex-horiz-start">
                          <div class="grid grid-20-auto"
                            *ngIf="conData.createdUser.toLowerCase() != loggedInUser.toLowerCase()">
                            <div class="text-a-right p-5">
                              <img src="../../../../assets/images/ico/user_ico.png" style="height: 25px;">
                            </div>
                            <div class="bubble">
                              <div class="txt">
                                <p class="name">{{conData.createdUser | technicalTranslate}}</p>
                                <p class="message" [innerHTML]="sanitizeHtml(conData?.description)"></p>
                                <span class="timestamp">{{conData.createdDt | date : 'medium'}}</span>
                              </div>
                              <div class="bubble-arrow"></div>
                            </div>
                          </div>
                        </div>
      
                        <!-- Message from logged-in user -->
                        <div class="flex flex-horiz-end">
                          <div class="grid grid-20-auto"
                            *ngIf="conData.createdUser.toLowerCase() == loggedInUser.toLowerCase()">
                            <div class="text-a-right p-5">
                              <img src="../../../../assets/images/ico/user_ico.png" style="height: 25px;">
                            </div>
                            <div class="bubble alt">
                              <div class="txt">
                                <p class="name alt">{{conData.createdUser | technicalTranslate}}</p>
                                <p class="message" [innerHTML]="sanitizeHtml(conData?.description)"></p>
                                <span class="timestamp">{{conData.createdDt | date : 'medium'}}</span>
                              </div>
                              <div class="bubble-arrow alt"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
      
                    <!-- Comment input box -->
                    <nz-comment *ngIf="data.status != 'COMPLETED' && (data.status == 'CREATED' || data.status == 'DRAFT')">
                      <nz-avatar nz-comment-avatar nzIcon="user"></nz-avatar>
                      <nz-comment-content>
                        <nz-form-item>
                          <angular-editor [(ngModel)]="notes[i]" id="index" [config]="editorConfig"
                            (ngModelChange)="editorMaxLength($event)"></angular-editor>
                          <p style="font-size: xx-small;">{{notes[i]?.length || 0}}/2000</p>
                        </nz-form-item>
                        <nz-form-item>
                          <div style="display: flex; justify-content: space-between;">
                            <button nz-button nzType="primary" [disabled]="!notes[i] || stageCd =='PA_ADJ_COMPLETE'"
                              (click)="replyToCollaboration(data.guid,data.collaborationTypeCd, i)">
                              Add comment
                            </button>
                          </div>
                        </nz-form-item>
                      </nz-comment-content>
                    </nz-comment>
                  </div>
      
                  <!-- Chaser Table -->
                  <div *ngIf="item.showChaser && data.collaborationTypeCd != 'ENQUIRY'">
                    <nz-table [nzData]="data.chasers" #charesTable [nzShowPagination]="false">
                      <thead>
                        <tr>
                          <th style="width:120px">{{'Chaser Schedule Date' | MMSTranslate}}</th>
                          <th style="width:120px">{{'Type' | MMSTranslate}}</th>
                          <th style="width:120px">{{'Status ' | MMSTranslate}}</th>
                          <th style="width:120px">{{'Chaser Run Date' | MMSTranslate}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let data of charesTable.data">
                          <td>{{commonUtilty.getLocalDateString(data?.chaserDt)}}</td>
                          <td>{{data?.typeCd | technicalTranslate}}</td>
                          <td>{{data?.statusCd | technicalTranslate}}</td>
                          <td>{{commonUtilty.getLocalDateString(data?.chaserRunDt)}}</td>
                        </tr>
                      </tbody>
                    </nz-table>
                  </div>
                </ng-template>
              </nz-list>
      
              <!-- Document manager inside panel -->
              <app-document-manager [mode]="'mini'" [requirementCd]="'ADDITIONAL_DOCUMENTS'"
                [clientRefGuid]="newCollaborationGuid" [heading]="'Documents'" [clientDO]="_IO.clientDOs" [requirements]="[]"
                [inputDataForEdit]="[]" [RequirementEntityGuid]="transactionGuid">
              </app-document-manager>
            </nz-collapse-panel>
          </ng-container>
        </td>
      </tr>
  </tbody>
  </nz-table>
</nz-collapse>

<!-- Empty state message -->
<app-generic-zero-ui [list]="dataList" icon="file-search" title="Collaboration Details"
  message="Collaboration details not available"></app-generic-zero-ui>

<!-- Reply Modal -->
<nz-modal [(nzVisible)]="referTaskVis" [nzTitle]="modalName" (nzOnCancel)="referTaskVis=false" nzWidth="600px"
  [nzFooter]="referFooter">
  <ng-container *nzModalContent>
    <div *ngIf="referTaskVis">
      <h4>Enter your Notes</h4>
      <angular-editor [(ngModel)]="note" id="'reply'" [config]="editorConfig"
        (ngModelChange)="editorMaxLength($event)"></angular-editor>
      <p style="font-size: xx-small;">
        {{note?.length || 0}}/{{'2000' || appMetadataHandler.featureFlags.MaxLengthValue}} Characters
      </p>
      <!-- Document manager inside modal -->
      <div>
        <app-document-manager *ngIf="modalName == 'Reply'" [mode]="'mini'" [requirementCd]="'ADDITIONAL_DOCUMENTS'"
          [clientRefGuid]="newCollaborationGuid" [heading]="'Documents'" [clientDO]="_IO.clientDOs" [requirements]="[]"
          [inputDataForEdit]="[]" [RequirementEntityGuid]="transactionGuid">
        </app-document-manager>
      </div>

    </div>
  </ng-container>
  <ng-template #referFooter>
    <button nz-button nzType="default" (click)="cancelTask()">Close</button>
    <button nz-button nzType="primary" (click)="markAsNoReply(modalName)" [nzLoading]="_openingCase">Confirm</button>
  </ng-template>
</nz-modal>